import React from 'react'
import { Line } from 'react-chartjs-2'
import styles from './Chart.module.sass'
import moment from "moment";
import {useWeb3App} from "../../../core/appContext";
import cn from "classnames";
import Loader from "react-loader-spinner";


export function Chart() {
    const ghApp = useWeb3App()
    const [chartData, setChartData] = React.useState({ data: [], options: [] })
    const [period, setPeriod] = React.useState('day')
    const [loading, setLoading] = React.useState(true)
    const getChart = async () => {
        setLoading(true)
        const chartData = await ghApp.getBalanceMovement(ghApp.active, period)

        let format
        switch(period) {
            case 'day': {
                format = "HH:mm"
                break
            }
            case 'month': {
                format = "DD/MM/YYYY"
                break
            }
            default: {
                format = "DD/MM/YYYY"
                break
            }
        }
        let points = []
        let labels = []
        chartData.forEach(i => {
            points.push(i.balance)
            labels.push(moment(i.date).format(format))
        })

        const maxCnrAmount = Math.max(...points)

        setChartData({
            data: {
                labels,
                datasets: [{
                    label: 'CNR',
                    data: points,
                    borderColor: '#06BE99',
                    fill: false,
                    cubicInterpolationMode: 'monotone',
                    tension: 0.4
                }],
            },
            options: {
                plugins: {
                    legend: {
                        display: false
                    }
                },
                responsive: true,
                interaction: {
                    intersect: false,
                },
                scales: {
                    x: {
                        display: true,
                        title: {
                            display: true,
                            text: 'Date'
                        }
                    },
                    y: {
                        display: true,
                        title: {
                            display: true,
                            text: 'CNR'
                        },
                        suggestedMin: 0,
                        suggestedMax: maxCnrAmount * 1.5
                    }
                }
            }})
        setLoading(false)
    }
    React.useEffect(() => {
        ghApp.on('tx:success', getChart)
    }, [])
    React.useEffect(() => {
        getChart()
    }, [period])

    return (
        <div className={styles.chart}>
            <div className={styles.wrap}>
                <div className={styles.btns}>
                    <div className={cn({[styles.active]: period === 'day'})} onClick={() => setPeriod('day')}>day</div>
                    <div className={cn({[styles.active]: period === 'week'})} onClick={() => setPeriod('week')}>week</div>
                    <div className={cn({[styles.active]: period === 'month'})} onClick={() => setPeriod('month')}>month</div>
                </div>
                {loading && (
                    <div className={styles.loader}>
                        <Loader
                            type="Bars"
                            color="#08A486"
                            height={100}
                            width={100}
                        />
                    </div>
                )}
                <Line data={chartData.data} options={chartData.options} />
            </div>
        </div>
    )
}
